module.exports = __webpack_public_path__ + "static/img/logo11.6e8f40cb.png";